import axios from 'axios';
import config from '../config';
import { getItemDatosSesion } from './manejosesion';

const token = getItemDatosSesion('token');
const empresaId = getItemDatosSesion('empresaActual')? JSON.parse(getItemDatosSesion('empresaActual')).Db:'';

const global_axios = axios.create({
    baseURL: config.api,
    timeout: config.request_timeout_api ,
    responseType: 'json'
});

if (token && empresaId){
    global_axios.defaults.headers.common['x-access-token'] = token;
    global_axios.defaults.headers.common['empresa'] = empresaId;
}

export default global_axios;